import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { DatePipe } from '@angular/common';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IFRNota } from '../../notes/notes.interfaces';
import { NotesServiceContactes } from './notes.service_contactes';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import { StripHtmlPipe } from '../../pipes/stripHTMLpipe';

import * as moment from 'moment';

@Component({
  selector: 'dialog-notes_contactes',
  templateUrl: './dialog.component.notes_contactes.html',
  styleUrls: ['./dialog.component.notes_contactes.scss'],
  providers: [NotesServiceContactes, DatePipe]
})

export class DialogNotesContactes {
  public error: string = '';
  public dia: string = null;
  public showAsyncProgress: boolean = false;
  public editNotesData: IFRNota;
  public userInfo: any = {};
  public projectes: any;
  public projecte: number = null;
  public quillPos: number = 0;
  public showDialog: boolean = false;

  @ViewChild('quillEditor', { static: false }) editor;

  constructor(public translate: TranslateService, public languageService: LanguageService, private datePipe: DatePipe, private notesService: NotesServiceContactes, public dialogRef: MatDialogRef<DialogNotesContactes>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any){ 
   this.editNotesData = data.nota;
   if(!this.editNotesData.observacions)this.editNotesData.observacions = "";
   if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
   this.userInfo = data.user;

   this.notesService.getAutocomplete('codiProjNota').subscribe(projecte => this.projectes = projecte, err => {return;});

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.editNotesData.data = this.datePipe.transform(new Date(),"yyyy-MM-dd");
    this.editNotesData.observacions = this.editor.quillEditor.root.innerHTML;
    this.dialogRef.close(this.editNotesData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit(){ }

  afegir(event){
    //data
    if(!event && this.editNotesData.observacions.indexOf("[" + this.dia + "]") == -1)
      this.editNotesData.observacions = "[" + this.dia + "] ("+this.userInfo.name+"): <p>&nbsp;</p>" + (this.editNotesData.observacions?this.editNotesData.observacions:'') + "<p>&nbsp;</p>";
    //seguiment
    if(event){
      this.projecte = event.value;
      this.editor.quillEditor.format('color', 'dark-green'); 
      this.editor.quillEditor.insertText(this.quillPos, "★ "+event.source.triggerValue+" ★", {'color': '#009900','bold': true});
    }
  }

  setPos(event){
    if(event.range)this.quillPos = event.range.index;
    else if(event.oldRange)this.quillPos = event.oldRange.index;
  }

}
